import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useEditUseCaseStyles = makeStyles({
  dialogContent: {
    paddingBottom: designTokens.spacing[8],
  },
});
